import Default from './Default';
import Display from './Display';
import Mini from './Mini';

const SkillReviewCard = { Default, Display, Mini };

export default SkillReviewCard;
